/** @module BarChartComponent */
import SegmentedBarChartViz from '../vizs/SegmentedBarChartViz'
import BaseComponent from './BaseComponent'

/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 * The segmented bar chart is used to display how values are distributed.
 *
 * ### Example Usage
 * ```javascript
 *
 *   import {SegmentedBarChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new SegmentedBarChart($el, data, config);
 *
 * ```
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 columns.
 *
 * Each row represents a segment. The first column should be the id/label of the segment. The second column represents the segment value.
 *
 * | category   | value |
 * | --------   | ----- |
 * |   Cat1     |   22.4|
 * |   Cat2     |   52.3|
 * |   Cat3     |   12.8|
 *
 * {.data-table}
 *
 * Each segment will be assigned a different color, to distinguish them inside the bar.
 *
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 * El gráfico de barra segmentada se utiliza para mostrar cómo se distribuyen los valores.
 *
 * ### Ejemplo de uso
 * ```javascript
 *
 *   import {SegmentedBarChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new SegmentedBarChart($el, data, config);
 *
 * ```
 *
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con 2 columnas.
 *
 * Cada fila representa un segmento. La primera columna debe ser la identificación/etiqueta del segmento. La segunda columna debe representar el valor de dicho segmento.
 *
 * | categoría   | valor |
 * | --------   | ------ |
 * |   Cat1     |    22.4|
 * |   Cat2     |    52.3|
 * |   Cat3     |    12.8|
 *
 * {.data-table}
 *
 * Cada segmento tendrá asignado un color distinto, para diferenciarlos dentro de la barra.
 *
 * */
export default class SegmentedBarChartComponent extends BaseComponent {
  static componentLabel = 'Segmented Bar Chart'
  static componentLabelEs = 'Gráfico de barra segmentada'
  static vizClass = SegmentedBarChartViz
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: 'y0', types: [Number], role: 'value', roleLabel: 'Value' },
  ]
  constructor($root, config, data) {
    super($root, config, data)
  }
  static defaultConfig = {
    title: this.componentLabel,
    TooltipBehavior: {
      axis: {
        y: {
          tooltipValueFormat: {
            exposed: true,
            nonEditable: false,
          },
        },
      },
    },
  }

  static dataRequirements = {
    recomendedMaxRows: 10,
    maxRows: 30,
    sign: 'positive', //'negative','any','both'
    avoidDates: true,
    requirementsStrength: 10,
  }
}
